import Urls from 'mangools-commons/dist/constants/Urls';

export const HELP_DROPDOWN_ITEMS = [
    {
        label: 'Guides on our blog',
        items: [
            {
                label: 'How to: SERPChecker guide',
                link: `${Urls.SERPCHECKER_GUIDE_URL}?ref=header-app-sch`,
                description: '8 min read',
            },
            {
                label: 'Keyword research guide',
                link: `${Urls.MANGOOLS_KEYWORD_RESEARCH_GUIDE_URL}?ref=header-app-sch`,
                description: '58 min read',
            },
            {
                label: 'SEO guide for beginners',
                link: `${Urls.MANGOOLS_SEO_ACADEMY_URL}?ref=header-app-sch`,
                description: '129 min read',
            },
        ],
    },
    {
        label: 'Other',
        items: [
            {
                label: 'Mangools Blog',
                link: `${Urls.MANGOOLS_BLOG_URL}?ref=header-app-sch`,
            },
            {
                label: 'Affiliate program',
                link: `${Urls.MANGOOLS_AFFILIATE_URL}?ref=header-app-sch`,
            },
            {
                label: 'FAQ',
                link: `${Urls.MANGOOLS_FAQ_URL}?ref=header-app-sch`,
            },
        ],
    },
];
